import React, { Component, useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "../../features/axiosHelper";

import Dropdown from "@/components/Dropdown/Dropdown";
import FadeInOut from "../../components/FadeInOut/FadeInOut";
import MenuBlock from "../../components/MenuBlock/MenuBlock";
import PopUp from "../../components/PopUp/PopUp";

import "./Notifications.css";

const CreateNewDigestPopUp = ({ onSave, openPopUp, setOpenPopUp }) => {
  const [name, setName] = useState("");

  const onChangeName = (event) => {
    setName(event.target.value);
  };
  const onClickSave = (event) => {
    onSave(name);
    setOpenPopUp(false);
  };
  return (
    <PopUp size={"small"} openPopUp={openPopUp} setOpenPopUp={setOpenPopUp}>
      <Stack
        flexDirection={"column"}
        justifyContent={"space-around"}
        style={{ height: "100%" }}
      >
        <div>
          <h1>Create new Digest</h1>
        </div>
        <div>
          <p>Enter name for new Digest</p>{" "}
          <TextField
            style={{ width: "100%" }}
            label="Enter name"
            value={name}
            onChange={onChangeName}
          />
        </div>
        <div align="right">
          <Button
            className="btn-primary"
            style={{ width: 180, marginTop: "12px" }}
            onClick={onClickSave}
          >
            Save
          </Button>
        </div>
      </Stack>
    </PopUp>
  );
};
const NotificationDigest = () => {
  dayjs.extend(utc);

  const dataPeriods = [
    { label: "Daily", key: 1 },
    { label: "Weekly", key: 2 },
    { label: "Monthly", key: 3 },
  ];

  const daysOfWeekList = [
    { label: " Sunday", key: 0 },
    { label: " Monday", key: 1 },
    { label: " Tuesday", key: 2 },
    { label: " Wednesday", key: 3 },
    { label: " Thursday", key: 4 },
    { label: " Friday", key: 5 },
    { label: " Saturday", key: 6 },
  ];

  const defaultDigest = {
    options: {
      includeSuccesses: false,
      includeWarnings: false,
      includeErrors: false,
      timeOfDayUTC: "",
    },
  };
  const digestPeriod = { daily: 0, weekly: 1, monthly: 2 };

  const [notificationGroups, setNotificationGroups] = useState([]);
  const [notificationDigestId, setNotificationDigestId] = useState(null);
  const [notificationDigests, setNotificationDigests] = useState([]);
  const [currentDigest, setCurrentDigest] = useState(defaultDigest);
  const [currentTimeOfDay, setCurrentTimeOfDay] = useState(null);

  const [openCreateDigest, setOpenCreateDigest] = useState(false);
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(false);

  const onClickedTestDigest = () => {
    axios({
      method: "POST",
      url: "Notifications/SendDigest",
    }).then((res) => {
      alert("Email sent.");
    });
  };

  const updateCurrentDigest = (field, value, isInOptions) => {
    let copyDigest = JSON.parse(JSON.stringify(currentDigest)); //deepcopy since state is readonly
    if (isInOptions) copyDigest.options[field] = value;
    else copyDigest[field] = value;
    setCurrentDigest(copyDigest);
  };

  const onSaveCreateNewDigest = (name) => {
    let index = notificationDigests.findIndex((x) => x.name == name);
    if (index != -1) {
      alert("Digest name is already in use.");

      setNotificationDigestId(notificationDigests[index].notificationDigestId);
      return;
    }

    let copyDigests = JSON.parse(JSON.stringify(notificationDigests)); //deepcopy since state is readonly
    let newDigest = defaultDigest;
    newDigest.notificationDigestId = -2;
    newDigest.name = name;
    copyDigests.push(newDigest);
    setNotificationDigests(copyDigests);
    setNotificationDigestId(-2);
  };
  const onChangeDaysOfWeek = (event, id) => {
    let copyDigest = JSON.parse(JSON.stringify(currentDigest)); //deepcopy since state is readonly

    let daysOfWeek = copyDigest.options.daysOfWeek;
    if (daysOfWeek == null) daysOfWeek = [];

    let i = daysOfWeek.indexOf(id);

    if (i == -1) daysOfWeek.push(id); //add item
    else if (i > -1) daysOfWeek.splice(i, 1); // remove item

    copyDigest.options.daysOfWeek = daysOfWeek;
    setCurrentDigest(copyDigest);
  };
  const onChangeDaysOfMonth = (event, id) => {
    let copyDigest = JSON.parse(JSON.stringify(currentDigest)); //deepcopy since state is readonly
    let daysOfMonth = copyDigest.options.daysOfMonth;
    let i = daysOfMonth.indexOf(id);

    if (i > -1) daysOfMonth.splice(i, 1);
    else daysOfMonth.push(id);

    copyDigest.options.daysOfMonth = daysOfMonth;
    setCurrentDigest(copyDigest);
  };

  const getNotificationDigests = () => {
    axios
      .get("/notifications/digests")
      .then((response) => {
        let responseData = response.data;
        responseData.push({
          name: "+ Create a New Digest",
          notificationDigestId: -1,
        });
        setNotificationDigests(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const getNotificationGroups = () => {
    axios
      .get("/notifications/groups")
      .then((response) => {
        const responseData = response.data;
        responseData.push({
          name: "None",
          notificationMailListId: -1,
        });
        setNotificationGroups(responseData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    getNotificationDigests();
    getNotificationGroups();
  }, []);

  const getCurrentDigest = () => {
    if (notificationDigestId == null) {
      setCurrentDigest(defaultDigest);
      return;
    }

    let digest = notificationDigests.find(
      (x) => x.notificationDigestId == notificationDigestId
    );
    setCurrentDigest(digest);

    if (digest.options.timeOfDayUTC != "") {
      let time = digest.options.timeOfDayUTC.match(
        "(\\d{2}):(\\d{2}):(\\d{2})"
      );
      let dateDayjs = dayjs()
        .utc()
        .hour(time[1])
        .minute(time[2])
        .second(0)
        .local();
      setCurrentTimeOfDay(dateDayjs);
    }
  };
  useEffect(() => {
    getCurrentDigest();
  }, [notificationDigestId]);

  const onClickSaveDigest = () => {
    // validation
    if (
      currentDigest.options.timeOfDayUTC == null ||
      currentDigest.options.timeOfDayUTC == ""
    ) {
      alert("Please enter a Time of Day");
      return;
    }

    let copyDigest = JSON.parse(JSON.stringify(currentDigest)); //deepcopy since state is readonly

    //ensure day of X is cleared if not used
    switch (currentDigest.period) {
      case 0: //daily
        copyDigest.options.daysOfWeek = null;
        copyDigest.options.daysOfMonth = null;
        break;
      case 1: //weekly
        copyDigest.options.daysOfMonth = null;
        break;
      case 2: //monthy
        copyDigest.options.daysOfWeek = null;
        break;
    }
    setIsSaveBtnDisabled(true);
    axios
      .post("/notifications/digests", copyDigest, null)
      .then((response) => {
        if (response.data != "") alert(response.data);
        getNotificationDigests();
        if (notificationDigestId == -2) {
          setNotificationDigestId(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setIsSaveBtnDisabled(false);
      });
  };

  return (
    <MenuBlock title="Setup Digest Notifications" maxHeight={1500}>
      <CreateNewDigestPopUp
        openPopUp={openCreateDigest}
        setOpenPopUp={setOpenCreateDigest}
        onSave={onSaveCreateNewDigest}
      ></CreateNewDigestPopUp>
      <div className="menuBlockContent">
        <Dropdown
          width={320}
          label="Select a Digest Configuration"
          onChange={(event) => {
            let selectedDigestId = event.target.value;
            if (selectedDigestId == -1) setOpenCreateDigest(true);
            else setNotificationDigestId(selectedDigestId);
          }}
          value={notificationDigestId}
          options={notificationDigests.map((x) => {
            return { key: x.notificationDigestId, label: x.name };
          })}
        ></Dropdown>
        <Button
          className="btn-secondary"
          style={{ width: 180, marginTop: "8px", float: "right" }}
          onClick={onClickedTestDigest}
          disabled={notificationDigestId == null}
        >
          Test Digest (debug)
        </Button>
        <p>
          Select the Notification statuses you would like to receive in your
          Digest.
        </p>
        <div name="Severity Checkboxes">
          <FormControlLabel
            control={
              <Checkbox
                checked={currentDigest.options.includeSuccesses}
                onChange={(event) => {
                  updateCurrentDigest(
                    "includeSuccesses",
                    event.target.checked,
                    true
                  );
                }}
              />
            }
            label="Successful"
            style={{ marginLeft: 5, minWidth: 180 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={currentDigest.options.includeWarnings}
                onChange={(event) => {
                  updateCurrentDigest(
                    "includeWarnings",
                    event.target.checked,
                    true
                  );
                }}
              />
            }
            label="Warnings"
            style={{ marginLeft: 5, minWidth: 180 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={currentDigest.options.includeErrors}
                onChange={(event) => {
                  updateCurrentDigest(
                    "includeErrors",
                    event.target.checked,
                    true
                  );
                }}
              />
            }
            label="Errors"
            style={{ marginLeft: 5, minWidth: 180 }}
          />
        </div>
      </div>
      <div className="menuBlockContent">
        <p>
          Select how often you would like to receive your digest and the time of
          day
        </p>
        <Dropdown
          width={320}
          label="Select a Period"
          value={currentDigest.period + 1}
          options={dataPeriods}
          onChange={(event) => {
            updateCurrentDigest("period", event.target.value - 1, false);
          }}
        ></Dropdown>
        <div style={{ marginTop: "12px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="Basic time picker"
              value={currentTimeOfDay}
              onChange={(time) => {
                updateCurrentDigest(
                  "timeOfDayUTC",
                  time.utc().format("HH:mm:ss"),
                  true
                );
              }}
            />
          </LocalizationProvider>
        </div>
      </div>
      <FadeInOut
        show={currentDigest.period == digestPeriod.weekly}
        duration={800}
        maxHeight={400}
      >
        <div className="menuBlockContent" name="Day of the Week">
          <p>Select a Day of the Week</p>
          {daysOfWeekList.map((day) => (
            <FormControlLabel
              key={day.key}
              control={
                <Checkbox
                  checked={
                    currentDigest.options.daysOfWeek != null &&
                    currentDigest.options.daysOfWeek.indexOf(day.key) > -1
                  }
                  onChange={(event) => onChangeDaysOfWeek(event, day.key)}
                />
              }
              label={day.label}
              style={{
                marginLeft: 5,
                minWidth: 120,
                height: 25,
                display: "inline-block",
              }}
            />
          ))}
        </div>
      </FadeInOut>
      <FadeInOut
        show={currentDigest.period == digestPeriod.monthly}
        duration={1000}
        maxHeight={700}
      >
        <div className="menuBlockContent" name="Day of the Month">
          <p>Select a Day of the Month</p>
          {Array.from(Array(31).keys()).map((i) => (
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  checked={
                    currentDigest.options.daysOfMonth != null &&
                    currentDigest.options.daysOfMonth.indexOf(i + 1) > -1
                  }
                  onChange={(event) => onChangeDaysOfMonth(event, i + 1)}
                />
              }
              label={i + 1}
              style={{
                marginLeft: 5,
                minWidth: 120,
                height: 25,
                display: "inline-block",
              }}
            />
          ))}
        </div>
      </FadeInOut>
      <div className="menuBlockContent">
        <p>Select the group to receive the Digest</p>
        <Dropdown
          width={320}
          label="Select Group"
          value={currentDigest.notificationMailListId}
          options={notificationGroups.map((x) => {
            return { key: x.notificationMailListId, label: x.name };
          })}
          onChange={(event) => {
            updateCurrentDigest(
              "notificationMailListId",
              event.target.value,
              false
            );
          }}
        ></Dropdown>
        <div align="right">
          <Button
            disabled={isSaveBtnDisabled}
            className="btn-primary"
            style={{ width: 180, marginTop: "12px" }}
            onClick={onClickSaveDigest}
          >
            Save
          </Button>
        </div>
      </div>
    </MenuBlock>
  );
};

export default NotificationDigest;
